import {
    EXPORT_EMPLOYEES_SALARY_REQUEST,
    EXPORT_EMPLOYEES_SALARY_SUCCESS,
    EXPORT_EMPLOYEES_SALARY_FAILURE,
} from "../actions";

const initialState = {
    loading: false,
    data: [],
    error: "",
};

const exportEmployeesSalaryReducer = (state = initialState, action) => {
    switch (action.type) {
        case EXPORT_EMPLOYEES_SALARY_REQUEST:
            return {
                error: "",
                loading: true,
                data: [],
            };

        case EXPORT_EMPLOYEES_SALARY_SUCCESS:
            return {
                loading: false,
                data: action.payload,
                error: "",
            };
        case EXPORT_EMPLOYEES_SALARY_FAILURE:
            return {
                loading: false,
                data: [],
                error: action.payload,
            };
        default:
            return state;
    }
}

export default exportEmployeesSalaryReducer;
